import { Button, styled } from '@mui/material';

export const TextButton = styled(Button)(() => ({
  color: 'text.secondary',
  textTransform: 'none',
  borderRadius: '8px',
  padding: '0 !important',
  minWidth: '0 !important',
  '&:hover': {
    backgroundColor: 'transparent',
    textDecoration: 'underline',
  },
}));
